import styled from "styled-components"
import { KBarPositioner, KBarAnimator, KBarSearch } from "kbar"
import { uiColorToBaseColor } from "styleguide/styles/colors"

export const StyledPositioner = styled(KBarPositioner)`
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  box-sizing: border-box;
`

export const StyledAnimator = styled(KBarAnimator)`
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`

export const StyledSearch = styled(KBarSearch)`
  padding: 16px;
  padding-right: 80px;
  font-size: 16px;
  width: 100%;
  border: none;
  outline: none;
  background: white;
  color: ${uiColorToBaseColor("darkGray")};

  &::placeholder {
    color: ${uiColorToBaseColor("gray")};
  }
`

export const ResultsContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding: 8px;
`

const getSectionColor = (section?: string) => {
  if (!section) return "transparent"
  if (section === "React on Rails") return uiColorToBaseColor("lighterGray")
  if (section === "React on Rails Pro") return uiColorToBaseColor("lightGray")
  if (section === "Control Plane Flow") return uiColorToBaseColor("gray")
  return "transparent"
}

export const ResultItem = styled.div<{ active: boolean; section?: string }>`
  padding: 12px 16px;
  padding-left: 12px;
  border-left: 2px solid ${(props) => getSectionColor(props.section)};
  border-radius: 4px;
  cursor: pointer;
  background: ${(props) =>
    props.active ? uiColorToBaseColor("lightestGray") : "transparent"};
  transition: all 0.1s ease;

  &:hover {
    background: ${uiColorToBaseColor("lightestGray")};
  }
`

export const ResultName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${uiColorToBaseColor("darkestGray")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  mark {
    background-color: ${uiColorToBaseColor("lightestRed")};
    color: inherit;
    font-weight: 700;
  }
`

export const CurrentBadge = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: ${uiColorToBaseColor("gray")};
  margin-left: auto;
  flex-shrink: 0;
`

export const ResultSubtitle = styled.div`
  font-size: 12px;
  color: ${uiColorToBaseColor("gray")};
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SectionHeader = styled.div`
  padding: 8px 16px 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${uiColorToBaseColor("gray")};
  letter-spacing: 0.5px;
`

export const EmptyStateHint = styled.div`
  padding: 12px 16px;
  margin: 8px 8px;
  background: ${uiColorToBaseColor("lightestGray")};
  border-radius: 4px;
  border-left: 3px solid ${uiColorToBaseColor("lighterGray")};
  font-size: 13px;
  color: ${uiColorToBaseColor("darkGray")};
  line-height: 1.4;
`
